import { API, graphqlOperation } from "aws-amplify";
import { updateAccount, updateAccountMini } from "./account-mutations";

// performDeleteAccount - call graphQl, no try-catch
// handleCreateAccount - with try-catch
// processUpdateAccount - process for lambda

export const sanitizeAccountLambda = ({
  chargeRules,
  checklists,
  history,
  historyLog,
  paymentTerm,
  products,
  savedAddress,
  savedAddresses,
  services,
  ...rest
}) => rest;

export const sanitizeAccount = (account) => {
  const sanitized = sanitizeAccountLambda(account);
  const { createdAt, updatedAt, ...rest } = sanitized;
  return rest;
};

// Email sync with the external system (QBO). QBO has one customer email and
// billingEmail is synced as its primary email; the contact email never syncs.
// - Account import from QBO: the QBO email sets both contact and billing email.
// - Account create: billingEmail syncs to QBO.
// - Account edit of contact email: saved to the DB only, nothing syncs.
// - Account edit of billing email: billingEmail syncs to QBO.
// - QBO customer edit of email: updates billingEmail (accountActions lambda).
// put it in
export const syncableAccountCreateProps = [
  { name: "active", required: false },
  { name: "address.city", required: false },
  { name: "address.country", required: false },
  { name: "address.state", required: false },
  { name: "address.street", required: false },
  { name: "address.zipCode", required: false },

  { name: "billingAddress.city", required: false },
  { name: "billingAddress.country", required: false },
  { name: "billingAddress.state", required: false },
  { name: "billingAddress.street", required: false },
  { name: "billingAddress.zipCode", required: false },
  { name: "billingEmail", required: false },
  { name: "businessName", required: true },
  { name: "einNumber", required: false },
  { name: "externalId", required: false },
  { name: "fax", required: false },
  { name: "id", required: true },
  { name: "paymentTerm.code", required: false },
  { name: "phone", required: false },
  { name: "website", required: false },
  // add any other fields you explicitly want to keep
];

// update the syncableAccountProps to include that field is required
export const syncableAccountUpdateProps = [
  // { name: "accountId", required: false }, // removed accountId
  { name: "active", required: false },
  { name: "address.city", required: false },
  { name: "address.country", required: false },
  { name: "address.state", required: false },
  { name: "address.street", required: false },
  { name: "address.zipCode", required: false },
  { name: "billingAddress.city", required: false },
  { name: "billingAddress.country", required: false },
  { name: "billingAddress.state", required: false },
  { name: "billingAddress.street", required: false },
  { name: "billingAddress.zipCode", required: false },
  { name: "billingEmail", required: false },
  { name: "businessName", required: true },
  { name: "einNumber", required: false },
  { name: "externalId", required: true },
  { name: "fax", required: false },
  { name: "id", required: true },
  { name: "paymentTerm.code", required: false },
  { name: "paymentTermId", required: false }, // used to set sync sabe button icon
  { name: "phone", required: false },
  { name: "website", required: false },
  // add any other fields you explicitly want to keep
];

// mutations.updateInvoice
export const performUpdateAccount = async (account) => {
  const accountInput = sanitizeAccount(account);
  return API.graphql(graphqlOperation(updateAccount, { input: accountInput }));
};

// custom-mutations.updateAccountMini
export const performUpdateAccountMini = async (account) => {
  const accountInput = sanitizeAccount(account);
  return API.graphql(
    graphqlOperation(updateAccountMini, { input: accountInput }),
  );
};

export const sanitizeProductLambda = ({
  account,
  history,
  historyLog,
  inventories,
  totalQuantityAvailable,
  velocityStats,
  ...rest
}) => rest;

export const sanitizeProduct = (product) => {
  const sanitized = sanitizeProductLambda(product);
  const { createdAt, updatedAt, ...rest } = sanitized;
  return rest;
};

// For updates to an existing product. The totals and the low-inventory flag are
// owned by the handleInventoryChange lambda, which writes them straight to
// DynamoDB as inventory moves; a form holds the record as of page load, so
// sending them back overwrites whatever the stream has written since. Callers
// that mean to change lowInventoryAlert set it after sanitizing, from totals
// they fetched just now. Create paths keep sanitizeProduct: they seed 0.
export const sanitizeProductEdit = (product) => {
  const {
    totalQuantityOnHand,
    totalQuantityCommitted,
    lowInventoryAlert,
    ...rest
  } = sanitizeProduct(product);
  return rest;
};
